import { z } from "zod";

export const branchSchema = z.object({
  branchName: z
    .string()
    .min(3, "Please enter a valid branch name (at least 3 characters).")
    .max(50, "Branch name must not exceed 50 characters."),

  branchEmail: z.email(
    "Please enter a valid email address (e.g. branch@company.com)."
  ),

  branchPhone: z
    .string()
    .min(9, "Please enter a valid phone number (at least 9 digits).")
    .max(15, "Phone number seems too long — please check again."),

  region: z.string().min(2, "Please select a region."),

  city: z.string().optional(),

  subCity: z.string().optional(),
  woreda: z.string().optional(),

  contactFullName: z
    .string()
    .min(
      6,
      "Please enter the contact person’s full name (at least 6 characters)."
    )
    .max(100, "Full name must not exceed 100 characters."),

  contactUsername: z
    .string()
    .min(4, "Username must be at least 4 characters long.")
    .max(30, "Username must not exceed 30 characters."),

  contactEmail: z.email(
    "Please enter a valid contact email (e.g. user@domain.com)."
  ),

  contactPhone: z
    .string()
    .min(9, "Please enter a valid contact phone number (at least 9 digits).")
    .max(15, "Contact phone number seems too long — please verify."),
});

export type BranchFormValues = z.infer<typeof branchSchema>;
